import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import classnames from 'classnames';

const ModalComponent = (props: any) => {
  const { children, isOpen, toggle, className, title, footer, backdrop } =
    props;

  return (
    <Modal
      isOpen={isOpen}
      backdrop={backdrop}
      toggle={toggle}
      centered
      size="xl"
      className={classnames('modalProperties', className)}
    >
      {title && (
        <ModalHeader toggle={toggle} className="title">
          {title}
        </ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Modal>
  );
};

export default ModalComponent;
